import { App } from '@openedx/frontend-base';
import { addScript, addSlot } from './utils';import { WidgetOperationTypes } from '@openedx/frontend-base';

const customApp: App = {
  appId: 'custom',
};
const IndigoPrimaryColorOverride = () => (
  <style>{`:root { --pgn-color-primary-base: #9D0054 !important; }`}</style>
);
addSlot(customApp, 
    {
      slotId: 'org.openedx.frontend.slot.header.desktop.v1',
      op: WidgetOperationTypes.APPEND,
      id: 'indigo_primary_color_override',
      element: (<IndigoPrimaryColorOverride />),
    });

export default customApp;